import React from 'react';

export default function Gallery(){
  return (
    <main style={{padding:24}}>
      <h1>Gallery</h1>
      <p>Product and factory photos will be showcased here.</p>
    </main>
  );
}
